import Link from "next/link";
import { scrollToElement } from "@/utils/scrollToElement";
import { StaticImageData } from "next/image";
import AmdLogo from "public/pricingPage/amd.webp";
import IntelLogo from "public/pricingPage/intel.png";
import AmdWLogo from "public/pricing/amd-w-logo.png";
import IntelWLogo from "public/pricing/intel-logo-white.png";

type BareMetalServerData = {
  sku: string;
  image: StaticImageData;
  wImage: StaticImageData;
  processor: string;
  cpu?: string;
  config?: string;
  memory: string;
  baseclock_boost: string;
  disk: string;
  bootDrives: string;
  price: string;
};

export const BAREMETAL_SERVER_DATA: BareMetalServerData[] = [
  {
    sku: "OMS-SC1-GP1",
    image: IntelLogo,
    wImage: IntelWLogo,
    processor: "2 X Intel Gold 6138 40C | 80T",
    cpu: "2 X Intel Gold ",
    config: "6138 40C | 80T",
    memory: "512GB",
    baseclock_boost: "2.00 GHz | 3.70 GHz",
    disk: "2 X 1.9TB SSD",
    bootDrives: "NA",
    price: "$500",
  },
  {
    sku: "OMS-SC1-GP2",
    image: IntelLogo,
    wImage: IntelWLogo,
    processor: "2 X Intel Gold 6136 24C | 48T",
    cpu: "2 X Intel Gold ",
    config: "6136 24C | 48T",
    memory: "384GB",
    baseclock_boost: "3.00 GHz | 3.70 GHz",
    disk: "2 X 1.9TB SSD",
    bootDrives: "NA",
    price: "$375",
  },
  {
    sku: "OMS-SC1-GP3",
    image: IntelLogo,
    wImage: IntelWLogo,
    processor: "2X Intel Xeon Silver 4314 32C | 64T",
    cpu: "2 X Xeon Silver",
    config: "4314 32C | 64T",
    memory: "512GB",
    baseclock_boost: "2.4 GHz | 3.4 GHz",
    disk: "2 X 3.84TB NVME",
    bootDrives: "2 X 240 GB",
    price: "$650",
  },
  {
    sku: "OMS-SC2-HC1",
    image: IntelLogo,
    wImage: IntelWLogo,
    processor: "2 X Intel Gold 6248 40C | 80T",
    cpu: "2 X Intel Gold ",
    config: "6248 40C | 80T",
    memory: "768GB",
    baseclock_boost: "2.50 GHz | 3.90 GHz",
    disk: "6 X 3.84TB NVME",
    bootDrives: "2 X 240 GB",
    price: "$900",
  },
  {
    sku: "OMS-SC2-HC2",
    image: IntelLogo,
    wImage: IntelWLogo,
    processor: "2 X Intel Gold 8268 48C | 96T",
    cpu: "2 X Intel Gold ",
    config: "8268 48C | 96T",
    memory: "1024GB",
    baseclock_boost: "2.90 GHz | 3.90 GHz",
    disk: "6 X 7.68TB NVME",
    bootDrives: "2 X 240 GB",
    price: "$1,200",
  },
  {
    sku: "OMS-SC2-HC3",
    image: IntelLogo,
    wImage: IntelWLogo,
    processor: "2X Intel Xeon Gold 6544Y 32C | 64T",
    cpu: "2 X Xeon Gold",
    config: "6544Y 32C | 64T",
    memory: "2048GB",
    baseclock_boost: "3.6 GHz | 4.1GHz",
    disk: "8 X 7.68TB NVME",
    bootDrives: "2 X 480 GB",
    price: "$1,650",
  },
  {
    sku: "AMD EPYC3 HC1",
    image: AmdLogo,
    wImage: AmdWLogo,
    processor: "AMD EPYC 7313 - 16C | 32T",
    cpu: "AMD EPYC",
    config: "7313 - 16C | 32T",
    memory: "256GB",
    baseclock_boost: "3.0 GHz | 3.7GHz",
    disk: "2 X 1.92TB NVME",
    bootDrives: "2 X 240 GB",
    price: "$675",
  },
  {
    sku: "AMD EPYC3 HC2",
    image: AmdLogo,
    wImage: AmdWLogo,
    processor: "AMD EPYC 9454 48C | 96T",
    cpu: "AMD EPYC",
    config: "9454 48C | 96T",
    memory: "512GB",
    baseclock_boost: "2.75 GHz | 3.8 GHz",
    disk: "2 X 7.68TB NVME",
    bootDrives: "2 X 240 GB",
    price: "$900",
  },
  {
    sku: "AMD EPYC2-HC3",
    image: AmdLogo,
    wImage: AmdWLogo,
    processor: "2 X AMD EPYC 7532 64C | 128T",
    cpu: "2 X AMD EPYC",
    config: "7532 64C | 128T",
    memory: "512GB",
    baseclock_boost: "2.4 GHz | 3.3 GHz",
    disk: "4 X 3.84TB NVME",
    bootDrives: "2 X 240 GB",
    price: "$575",
  },
  {
    sku: "AMD EPYC2-HC4",
    image: AmdLogo,
    wImage: AmdWLogo,
    processor: "2 X AMD EPYC 9354 64C | 128T",
    cpu: "2 X AMD EPYC",
    config: "9354 64C | 128T",
    memory: "1024GB",
    baseclock_boost: "3.25 GHz | 3.75 GHz",
    disk: "6 X 7.68TB NVME",
    bootDrives: "2 X 480 GB",
    price: "$1,599",
  },
  {
    sku: "OMS-RYZEN-GP1",
    image: AmdLogo,
    wImage: AmdWLogo,
    processor: "AMD RYZEN 3900X",
    cpu: "AMD RYZEN",
    config: "3900X 12C | 24T",
    memory: "64GB",
    baseclock_boost: "3.8 GHz | 4.6 GHz",
    disk: "2 X 2TB",
    bootDrives: "NA",
    price: "$140",
  },
  {
    sku: "OMS-RYZEN-GP2",
    image: AmdLogo,
    wImage: AmdWLogo,
    processor: "AMD Ryzen 9 7950X3D 16C | 32T",
    cpu: "AMD RYZEN",
    config: "7950X3D 16C | 32T",
    memory: "128GB",
    baseclock_boost: "4.2 GHz | 5.7 GHz",
    disk: "2 X 4TB",
    bootDrives: "2 X 512 GB",
    price: "$250",
  },
  {
    sku: "OMS-RYZENTR-1",
    image: AmdLogo,
    wImage: AmdWLogo,
    processor: "AMD TR PRO 7965WX 24C | 48T",
    cpu: "AMD TR PRO",
    config: "7965WX 24C | 48T",
    memory: "512GB",
    baseclock_boost: "4.2 GHz | 5.3 GHz",
    disk: "2 X 2TB",
    bootDrives: "2 X 512 GB",
    price: "$899",
  },
  {
    sku: "OMS-RYZENTR-2",
    image: AmdLogo,
    wImage: AmdWLogo,
    processor: "AMD TR PRO 7995WX 96C | 192T",
    cpu: "AMD TR PRO",
    config: "7995WX 96C | 192T",
    memory: "2048GB",
    baseclock_boost: "2.5 GHz | 5.1 GHz",
    disk: "4 X 4TB",
    bootDrives: "2 X 512 GB",
    price: "$2,500",
  },
];

export const FOOTER_CONSTANTS = {
  btnText: "Ready To Buy?",
  text1: (
    <>
      We have more servers for your business. Prices are estimates and may vary hourly,
      monthly, or yearly as per your needs. Please Contact{" "}
      <Link
        href="#contact-us"
        onClick={(e) => {
          e.preventDefault();
          scrollToElement("contact-us", 120);
        }}
        style={{ textDecoration: "underline", color: "#1E87F0", fontWeight: 700 }}
      >
        sales
      </Link>{" "}
      for more information.
    </>
  ),
};
